import Header from "@components/Header.jsx";

import {useEffect, useState} from "react";
import fetchContent from "@/utils/fetchContent.jsx";

const FaqPage = () => {

    const [content, setContent] = useState("");

    useEffect(() => {
        const loadContent = async () => {
            const data = await fetchContent("faq", "doc1");
            setContent(data);
        };

        loadContent();
    }, []);


    return (
        <div className={`faq-page`}>
            <div className={`wrapper`}>
                <div className={`page page-app`}>
                    <Header title='FAQ' />
                    <div
                        className="page-content"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </div>
            </div>
        </div>

    )
}

export default FaqPage;